import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from 'loyal-react'
import { Link } from 'react-router-dom'
import MediaQuery from 'react-responsive'

const ShowcaseHeader = ({ title, mobileTitle, viewAllPath }) => (
  <div className='row mx-0'>
    <div className='col mr-auto mb-2 mx-0 px-0'>
      <h2 className='txt-font-title color-title d-none d-md-block px-md-0 px-2 pt-0 pt-md-1 pt-xl-0'>
        {title}
      </h2>
      <h2 className='txt-font-title color-title d-block d-md-none px-md-0 pt-1 px-0'>
        {mobileTitle}
      </h2>
    </div>
    <MediaQuery minDeviceWidth={426}>
      <div className='col-auto'>
        <Link
          to={viewAllPath}
          className='card-see-all d-block btn btn-sm btn-flat btn-icon txt-button txt-font-body btn-invert'
        >
          Ver todos <Icon iconName='icon-sm icon_right' />
        </Link>
      </div>
    </MediaQuery>
  </div>
)

ShowcaseHeader.propTypes = {
  title: PropTypes.string,
  mobileTitle: PropTypes.string,
  viewAllPath: PropTypes.string
}

ShowcaseHeader.defaultProps = {
  viewAllPath: '/search'
}

export default ShowcaseHeader



// WEBPACK FOOTER //
// ./src/Catalog/Showcase/ShowcaseHeader.js